<template>
  <div class="home">
    <div class="buttonList">
      <div class="searchBox">
        <!-- <el-select
          v-model="departCode"
          placeholder="所属部门"
          clearable
          filterable
          @change="queryReportInfo"
        >
          <el-option
            v-for="(item,key) in departmentList"
            :key="key"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select> -->
        <el-cascader
          v-model="departCode"
          @change="queryReportInfo"
          :options="departmentListTree"
          :props="casProps"
          :filterable="true"
          placeholder="请选择部门"
          :show-all-levels="false"
        ></el-cascader>
      </div>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-edit"
        @click="exportAllList()"
        v-if="getButtonListRules(14010101)"
      >导出</el-button>
    </div>
    <div class="top-menu">
      <div
        class="item"
        @click="$router.push(`/personnelAdmin/entry?tabName=1&departCode=${departCode||''}`)"
      >
        <div class="left-icon">
          <img
            src="@/assets/img/icon-drz.png"
            alt
          />
          <span>待入职</span>
        </div>
        <div class="right-num">
          <span>{{waitEntry}}</span>
        </div>
      </div>

      <div
        class="item"
        @click="$router.push(`/personnelAdmin/staff?tabName=1&departCode=${departCode||''}&workingStatus=1`)"
      >
        <div class="left-icon">
          <img
            src="@/assets/img/icon-dzz.png"
            alt
          />
          <span>待转正</span>
        </div>
        <div class="right-num">
          <span>{{waitWork}}</span>
        </div>
      </div>

      <div
        class="item"
        @click="$router.push(`/personnelAdmin/dimission?tabName=1&departCode=${departCode||''}`)"
      >
        <div class="left-icon">
          <img
            src="@/assets/img/icon-dlz.png"
            alt
          />
          <span>待离职</span>
        </div>
        <div class="right-num">
          <span>{{waitQuit}}</span>
        </div>
      </div>

      <div class="item-right">
        <div class="left-num">
          <span class="num">{{workingNumber}}</span>
          <span class="txt">在职总人数</span>
        </div>
        <div class="right-box">
          <el-row>
            <el-col
              :xl="12"
              :lg="12"
              class="item-col"
            >
              <span class="round"></span>
              <span class="txt">本月入职 {{monthEntry}}</span>
            </el-col>
            <el-col
              :xl="12"
              :lg="12"
              class="item-col"
            >
              <span class="round"></span>
              <span class="txt">本月已转正 {{monthWork}}</span>
            </el-col>
            <el-col
              :xl="12"
              :lg="12"
              class="item-col"
            >
              <span class="round"></span>
              <span class="txt">本月离职 {{monthQuit}}</span>
            </el-col>
            <el-col
              :xl="12"
              :lg="12"
              class="item-col"
            >
              <span class="round"></span>
              <span class="txt">逾期未转正 {{monthNoWork}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="el-box staff-structure">
      <div class="title">人员结构</div>
      <div class="content">
        <el-row>
          <el-col :span="8">
            <div
              id="chart1"
              class="echartsPie"
            ></div>
          </el-col>
          <el-col :span="8">
            <div
              id="chart2"
              class="echartsPie"
            ></div>
          </el-col>
          <el-col :span="8">
            <div
              id="chart3"
              class="echartsPie"
            ></div>
          </el-col>
          <el-col :span="8">
            <div
              id="chart4"
              class="echartsPie"
            ></div>
          </el-col>
          <el-col :span="8">
            <div
              id="chart5"
              class="echartsPie"
            ></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="el-box staff-dynamic">
      <div class="title">人员动态</div>
      <div class="content">
        <el-row>
          <el-col :span="12">
            <div
              id="chart6"
              class="echartsline"
            ></div>
            <!-- <div class="name">
              <span>在岗人员分析</span>
            </div>-->
          </el-col>
          <el-col :span="12">
            <div
              id="chart7"
              class="echartsline"
            ></div>
            <!-- <div class="name">
              <span>在岗人员趋势</span>
            </div>-->
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ApiHome from '@/api/home';
// import ApiattendanceAdmin from '@/api/attendanceAdmin';
import ApiOrganizeAdmin from '@/api/organizeAdmin';

export default {
  name: 'home',
  components: {},
  created() {
    this.startloding();
    this.requsetDepartmentList(''); // 部门列表
    Promise.all([
      this.staffanalyzeAnalyze(''),
      this.startDrawPie('D'),
      this.staffanalyzeLinechart(''),
    ]).then(() => {
      this.closeLoding();
    }).catch(error => {
      console.log(error);
      this.closeLoding();
    });
  },
  data() {
    return {
      departCode: 'D',
      departmentList: [], // 部门列表
      departmentListTree: [],
      casProps: {
        checkStrictly: true,
        value: 'code',
        label: 'name',
        emitPath: false,
      },
      monthEntry: 0, // 本月入职
      monthNoWork: 0, // 本月未转正
      monthQuit: 0, // 本月离职
      monthWork: 0, // 本月转正
      waitEntry: 0, // 待入职
      waitQuit: 0, // 待离职
      waitWork: 0, // 待转正
      workingNumber: 0, // 在职人数
    };
  },
  mounted() {},
  methods: {
    // 请求关于部门的信息
    queryReportInfo(departCode) {
      if (!departCode) {
        return;
      }
      this.startloding();
      Promise.all([
        this.staffanalyzeAnalyze(departCode),
        this.startDrawPie(departCode),
        this.staffanalyzeLinechart(departCode),
      ]).then(() => {
        this.closeLoding();
      }).catch(() => {
        this.closeLoding();
      });
    },
    // 请求部门列表
    requsetDepartmentList() {
      // ApiattendanceAdmin.atteDailyDeparts({})
      ApiOrganizeAdmin.reqDeparts({}, '/1')
        .then(res => {
          this.departmentList = res.result;
          this.departmentListTree = this.data2TreeData(
            'id',
            'parentId',
            res.result,
          );
          // this.departmentListTree = this.departmentListTree[0].children;
        })
        .catch(error => {
          this.$message.error(`${error.message}`);
        });
    },
    staffanalyzeAnalyze(departCode) {
      return new Promise((resolve, reject) => {
        ApiHome.hrStaffanalyzeAnalyze({ departCode })
          .then(res => {
            this.monthEntry = res.result.monthEntry;
            this.monthNoWork = res.result.monthNoWork;
            this.monthQuit = res.result.monthQuit;
            this.monthWork = res.result.monthWork;
            this.waitEntry = res.result.waitEntry;
            this.waitQuit = res.result.waitQuit;
            this.waitWork = res.result.waitWork;
            this.workingNumber = res.result.workingNumber;
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    startDrawPie(departCode) {
      return new Promise((resolve, reject) => {
        ApiHome.hrStaffanalyzePiechart({ departCode })
          .then(res => {
          // 男女比例
            this.drawPie(
              'chart1',
              res.result.gender,
              '男女比例',
              `${res.result.gender[0] ? res.result.gender[0].rate : ''}:${res.result.gender[1] ? res.result.gender[1].rate : ''}`,
            );
            // 平均年龄
            this.drawPie(
              'chart2',
              res.result.age,
              '平均年龄',
              res.result.ageRate,
            );
            // 平均司龄
            this.drawPie(
              'chart3',
              res.result.companyAge,
              '平均司龄',
              res.result.companyAgeRate,
            );
            // 未婚占比
            this.drawPie(
              'chart4',
              res.result.marital,
              '未婚占比',
              res.result.marital[0] ? res.result.marital[0].rate : '',
            );
            // 学历结构
            this.drawPie('chart5', res.result.edu, '学历结构');
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    staffanalyzeLinechart(departCode) {
      return new Promise((resolve, reject) => {
        ApiHome.hrStaffanalyzeLinechart({ departCode })
          .then(res => {
            this.drawline1([
              res.result.entryList,
              res.result.quitList,
              res.result.dismissList,
              res.result.netAddedList,
            ]);
            this.drawline2(res.result.workingList);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 画饼图
    drawPie(el, data, text, number) {
      const legendData = [];
      data.forEach(element => {
        legendData.push(element.name);
      });
      this.myChart = this.$echarts.init(document.getElementById(el));
      this.myChart.clear();
      this.myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        color: [
          '#97C6FF',
          '#FF9590',
          '#F6D046',
          '#C4D962',
          '#8BE39A',
          '#84D8FO',
        ],
        legend: {
          orient: 'vertical',
          x: 'right',
          data: legendData,
        },

        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter() {
                  let html = '';
                  html = `${text}${number ? ':\n\r\n' : ''}${number || ''}`;
                  return html;
                },
                textStyle: {
                  fontSize: 15,
                  color: '#999999',
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data,
          },
        ],
      });
    },
    // 画折线图 在岗人员分析
    drawline1(data) {
      const legend = ['本月入职', '本月主动离职', '本月被动离职', '人员净增数'];
      const xAxis = [];
      const series = [];
      data[0].forEach(element => {
        xAxis.push(element.month);
      });
      data.forEach((element, index) => {
        series.push({
          name: legend[index],
          type: 'line',
          stack: '总量',
          smooth: true,
          data: [],
        });
      });
      data.forEach((element, index) => {
        element.forEach(el => {
          series[index].data.push(el.value);
        });
      });
      this.myChart = this.$echarts.init(document.getElementById('chart6'));
      this.myChart.clear();
      this.myChart.setOption({
        title: {
          text: '在岗人员分析',
          x: 'center',
          bottom: '10',
        },
        tooltip: {
          trigger: 'axis',
        },
        color: [
          '#97C6FF',
          '#FF9590',
          '#FFAA71',
          '#F6D046',
          '#C4D962',
          '#8BE39A',
          '#84D8FO',
        ],
        legend: {
          data: legend,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '50',
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: 'category',
          data: xAxis,
        },
        yAxis: {
          type: 'value',
        },
        series,
      });
    },
    // 画折线图 在岗人员趋势
    drawline2(data) {
      const xAxis = [];
      const series = [];
      data.forEach(element => {
        xAxis.push(element.month);
        series.push(element.value);
      });
      this.myChart = this.$echarts.init(document.getElementById('chart7'));
      this.myChart.clear();
      this.myChart.setOption({
        title: {
          text: '在岗人员趋势',
          x: 'center',
          bottom: '10',
        },
        xAxis: {
          type: 'category',
          data: xAxis,
        },
        legend: {
          data: ['在岗人员总数'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '50',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
        },
        color: ['#97C6FF'],
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '在岗人员总数',
            data: series,
            type: 'line',
            smooth: true,
          },
        ],
      });
    },
    exportAllList() {
      const param = Object.assign({}, {});
      this.startloding('正在导出，请稍后...');
      ApiHome.hrStaffanalyzeExport(param)
        .then(res => {
          const content = res;
          const blob = new Blob([content]); // 构造一个blob对象来处理数据
          const fileName = 'staff_analyze.xlsx';
          // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
          // IE10以上支持blob但是依然不支持download
          if ('download' in document.createElement('a')) {
            // 支持a标签download的浏览器
            const link = document.createElement('a'); // 创建a标签
            link.download = fileName; // a标签添加属性
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click(); // 执行下载
            URL.revokeObjectURL(link.href); // 释放url
            document.body.removeChild(link); // 释放标签
          } else {
            // 其他浏览器
            navigator.msSaveBlob(blob, fileName);
          }
          this.closeLoding();
        })
        .catch(error => {
          this.$message.error(`${error.message}`);
          this.closeLoding();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.buttonList {
  .searchBox {
    width: 220px;
  }
  margin: 10px 0;
  display: flex;
}
.echartsPie {
  width: 100%;
  height: 200px;
  overflow: auto;
}
.echartsline {
  width: 100%;
  height: 600px;
  overflow: auto;
}
.home {
  margin-top: 20px;
  display: block !important;
  .top-menu {
    display: flex;
    margin-bottom: 20px;
    .item {
      flex: 1;
      width: 14.6vw;
      min-height: 140px;
      background: #fff;
      border-radius: 8px;
      margin-right: 0.7vw;
      display: flex;
      align-items: center;
      justify-content: space-around;
      transition: all 0.3s;
      .left-icon {
        width: 50px;
        text-align: center;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
        text-align: center;
      }
      .right-num {
        font-family: PingFangSC-Medium;
        font-size: 40px;
        color: #333333;
        letter-spacing: 0;
        text-align: right;
      }
      &:hover {
        cursor: pointer;
        box-shadow: 0px 5px 10px rgba(0,0,0,0.2);
      }
    }
    .item-right {
      width: 476px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .left-num {
        display: flex;
        flex-direction: column;
        padding: 0 30px;
        .num {
          font-size: 40px;
          color: #333333;
          letter-spacing: 0;
          text-align: right;
        }
        .txt {
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .right-box {
        flex: 1;
        .item-col {
          margin: 11px 0;
          .round {
            display: inline-block;
            width: 8px;
            height: 8px;
            border: 1px solid #bb86fc;
            border-radius: 50%;
            margin-right: 10px;
          }
          .txt {
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
          }
        }
      }
    }
  }
  .el-box {
    margin-bottom: 20px;
    width: 100%;
    background: #fff;
    border-radius: 8px;
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      text-indent: 30px;
      font-weight: bold;
    }
    .content {
      padding-right: 80px;
    }
  }
}
</style>
